/**
 * @Description 新增区域
 */

import { FC, useEffect, useMemo, useState } from 'react';
import V2Title from '@/common/components/Feedback/V2Title';
import AreaDetailDrawer from '@/common/components/business/AreaDetailDrawer';
import { isNotEmptyAny } from '@lhb/func';
import { modelClusterApprovalDetail } from '@/common/api/expandStore/approveworkbench';
import styles from './index.module.less';
import cs from 'classnames';
import ClusterMap from './ClusterMap';
import { useMethods } from '@lhb/hook';

interface DrawerData{
  open: boolean;
  id: string;
}

const ModelCluster: FC<{
  modelClusterId,
  aprDetail
}> = ({
  modelClusterId,
  aprDetail
}) => {
  const [detail, setDetail] = useState<any>({});
  const [drawerData, setDrawerData] = useState<DrawerData>({ // 选址地图详情抽屉
    open: false,
    id: ''
  });

  useEffect(() => {
    modelClusterId && getDetail();
  }, [modelClusterId]);

  const getDetail = async () => {
    const res = await modelClusterApprovalDetail({ modelClusterId });
    isNotEmptyAny(res) && setDetail(res);
  };

  const basicInfos = useMemo(() => {
    if (!isNotEmptyAny(detail)) return [];
    const { modelClusterName, provinceName, cityName, districtName, levelCategoryName } = detail;

    const pcdInfos: any = [];
    provinceName && pcdInfos.push(provinceName);
    cityName && pcdInfos.push(cityName);
    districtName && pcdInfos.push(districtName);

    return [
      { label: '名称', value: modelClusterName, event: 'handleClusterName' },
      { label: '位置', value: pcdInfos.length ? pcdInfos.join('/') : '' },
      { label: '类型', value: levelCategoryName },
      { label: '原因', value: aprDetail?.applyReason, textarea: true },
    ];
  }, [detail]);

  const methods = useMethods({
    handleClusterName: () => {
      if (!modelClusterId) return;
      setDrawerData({
        open: true,
        id: modelClusterId
      });
    }
  });

  return isNotEmptyAny(detail) ? (<>
    <div className={styles.modelCluster}>
      <div className={styles.basicInfo}>
        <V2Title
          type='H2'
          divider
          text='基本信息'
        />
        {
          basicInfos.map((item: any, index: number) => (<div key={index} className={index ? 'mt-16' : 'mt-12'}>
            <div className={styles.label}>{item.label}</div>
            <div className={cs(
              styles.value,
              item.textarea ? styles.textarea : styles.text,
              item.event && styles.link
            )}>
              {item.event
                ? <div onClick={() => methods[item.event]()}>{item.value || '-'}</div>
                : (item.value || '-')}
            </div>
          </div>))
        }
      </div>
      <div className={styles.basicMap}>
        <ClusterMap clusterInfo={detail}/>
      </div>
    </div>

    <AreaDetailDrawer
      drawerData={drawerData}
      setDrawerData={setDrawerData}
      viewChanceDetail={false}
      showCollect={false}
      showTaskCreate={false}
      showTaskHistory={false}
      showGatherCreate={false}
    />
  </>) : <></>;
};
export default ModelCluster;
